import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2 text-xl font-bold font-heading tracking-wide"
          >
            <span className={`transition-colors ${scrolled ? 'text-primary-600' : 'text-background-50'}`}>
              猛男诞生记
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/')
                  ? scrolled
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-background-50 bg-white/15'
                  : scrolled
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                    : 'text-background-50/85 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive(`/category/${cat.slug}`)
                    ? scrolled
                      ? 'text-primary-600 bg-primary-50'
                      : 'text-background-50 bg-white/15'
                    : scrolled
                      ? 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                      : 'text-background-50/85 hover:text-background-50 hover:bg-white/10'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/about')
                  ? scrolled
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-background-50 bg-white/15'
                  : scrolled
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
                    : 'text-background-50/85 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              关于我们
            </Link>
          </nav>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled ? 'text-foreground-800 hover:bg-background-100' : 'text-background-50 hover:bg-white/15'
            }`}
            aria-label="打开菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 shadow-lg">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className={`px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                isActive('/') ? 'text-primary-600 bg-primary-50' : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                  isActive(`/category/${cat.slug}`)
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                isActive('/about') ? 'text-primary-600 bg-primary-50' : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}